<template>
  <div class="pages">
    <div class="cus" @click="goToInquiry()">
      <img src="/static/home/tools/iq.png" class="rImg iq" />
      <div class="text">{{ $t('main.productInquiry') }}</div>
      <div class="total">{{ inquiryTotal }}</div>
    </div>
    <div class="cus" @click="goToShopping()">
      <img src="/static/home/tools/gw.png" class="rImg gw" />
      <div class="text">{{ $t('main.shopCar') }}</div>
      <div class="total">{{ total }}</div>
    </div>
    <div class="cus" @click="goToCompare()">
      <img src="/static/home/tools/vs.png" class="rImg vs" />
      <div class="total">{{ compare }}</div>
    </div>
    <el-popover
      placement="left"
      width="400"
      trigger="click"
    >
      <div class="shareshow">
        <div class="share-title">
          <div class="share-mail">
            <span><i class="el-icon-message"></i> {{ $t('main.shareToEmail') }}</span>
          </div>
          <el-button
              @click="subShare"
              size="small"
              class="share-button">
            {{ $t('main.send') }}
          </el-button>
        </div>
        <div class="share-content">
          <div class="input-box">
            <div class="input-title">
              <span class="required">*</span>
              {{ $t('main.yourEmail') }}：
            </div>
            <el-input
                class="input"
                v-model="send_email"
                :placeholder="$t('main.yourEmail')"
                size="medium">
            </el-input>
          </div>
          <div class="input-box">
            <div class="input-title">
              <span class="required">*</span>
              {{ $t('main.friedEmail') }}：
            </div>
            <el-input
                class="input"
                v-model="send_to_email"
                :placeholder="$t('main.friedEmail')"
                size="medium">
            </el-input>
          </div>
          <div class="input-box">
            <div class="input-title">
              <span class="required">*</span>
              {{ $t('main.comments') }}：
            </div>
            <el-input
                class="input"
                v-model="share_content"
                :placeholder="$t('main.shareContent')"
                type="textarea"
                :rows="3">
            </el-input>
          </div>
        </div>
      </div>
      <div class="cus" slot="reference">
        <img src="/static/home/tools/fx.png" class="rImg fx" />
      </div>
    </el-popover>
    <div class="cus" @click="goToTop()">
      <img src="/static/home/tools/db.png" class="rImg db" />
    </div>
  </div>
</template>

<script>
import { addShare } from "@/api";
import Cookies from "js-cookie";
import { comparelist, Shopcarlist } from "@/api/shopcar";
import { Inquirylist } from "@/api/inquiry";
import {
  getBlokcList
} from "@/api";
import Cookie from "js-cookie";

export default {
  data() {
    return {
      total: 0, // 购物车数量
      inquiryTotal: 0, // 产品咨询数量
      compare: 0, // 对比数量
      dialogVisible: false, //分享的dialog
      send_email: "",
      send_to_email: "",
      send_phone: "",
      send_to_phone: "",
      share_url: "http://welbensx.qa/fjlryvex",
      share_content:"",
      email_config: "",
      sms_config: "",
      send_type: 1,
      contactList:[]
    };
  },
  props: ["siteConfig", "isCN"],
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.carNum": function(newV) {
      if (newV) {
        this.getCarNums();
        this.$store.dispatch("setCarNum", false);
      }
    },
    "$store.state.inquiryNum": function(newV) {
      if (newV) {
        this.getInquiryNum();
        this.$store.dispatch("setInquiryNum", false);
      }
    },
    "$store.state.compareNum": function(newV) {
      if (newV) {
        this.getCompareNums();
        this.$store.dispatch("setCompareNum", false);
      }
    },
    '$store.state.userInfo':{
      handler(newValue) {
        // 处理数据变化
        this.init();
      },
      deep: true // 如果需要监听对象内部属性的变化，需要设置deep为true
    }
  },
  mounted() {
    this.init();
    this.send_email = Cookies.get("userinfo") && (JSON.parse(Cookies.get("userinfo")) && JSON.parse(Cookies.get("userinfo")).email) || ""
  },
  methods: {
    init() {
      this.getCarNums();
      this.getInquiryNum();
      this.getCompareNums();
      this.getContact();
    },
    getContact(){
      var params = {
        "req": {
          "page": 1,
          "where": [
            {
              "condition": "2",
              "filed": "type",
              "expression": "="
            },
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            },
            {
              "condition": "1",
              "filed": "is_show",
              "expression": "="
            }
          ],
          "limit": 20,
          "order": "orderby desc"
        }
      };
      getBlokcList(params).then(res => {
        if(res.rsp.code === 0) {
            //  this.bannerList = res.data.list;
            this.contactList = res.data.list;
        }
      });
    },
    getCarNums() {
      let params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      };
      Shopcarlist(params).then(res => {
        if(res.rsp.code === 0) {
          this.total = res.data.total;
          const carList = {
            pid:[],
            number:[]
          };
          res.data.list.map(function(item) {
            carList.pid.push(item.product_id);
            carList.number.push(item.number);
          });
          this.$store.dispatch(
              "setCarList",
              carList
          );
        }
      });
    },
    getInquiryNum() {
      let params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      };
      Inquirylist(params).then(res => {
        if(res.rsp.code === 0) {
          this.inquiryTotal = res.data.total;
          const inquiryList = {
            pid:[],
            number:[]
          };
          res.data.list.map(function(item) {
            inquiryList.pid.push(item.product_id);
            inquiryList.number.push(item.number);
          });
          this.$store.dispatch(
              "setInquiryList",
              inquiryList
          );
        }
      });
    },
    getCompareNums() {
      let params = {
        req: {
          page: 1,
          limit: 100000,
          where: [
            {
              "condition": "" + parseInt(Cookies.get("siteInfo")),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      };
      comparelist(params).then(res => {
        if(res.rsp.code === 0) {
          this.compare = res.data.total;
          this.$store.dispatch(
            "setCompareList",
            res.data.list.map(item => item.product_id)
          );
        }
      });
    },
    goToCompare() {
      this.$router.push("/compare");
    },
    goToInquiry() {
      this.$router.push("/inquiry");
    },
    goToShopping() {
      this.$router.push("/shoppingCart");
    },
    goToTop() {
      window.scrollTo(0, 0);
    },
    share() {
      if (this.dialogVisible == true) {
        this.dialogVisible = false;
      } else {
        this.dialogVisible = true;
      }
    },
    //关闭弹出框
    handleClose() {
      this.dialogVisible = false;
    },

    subShare() {
      const paramsSubmit = {
        req: {
          send_email: this.send_email,
          send_to_email: this.send_to_email,
          send_phone: this.send_phone,
          send_to_phone: this.send_to_phone,
          share_url: location.href,
          share_content: this.share_content,
          email_config: "",
          sms_config: "",
          send_type: 1,
        },
      };
      addShare(paramsSubmit).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success",
          });
          this.dialogVisible = false;
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.rImg {
  width: 60px;
  height: 60px;
  margin-top: 10px;
}
.cus:hover img.iq {
  content: url('/static/home/tools/iq-choose.png');
}
.cus:hover img.gw {
  content: url('/static/home/tools/gw-choose.png');
}
.cus:hover img.vs {
  content: url('/static/home/tools/vs-choose.png');
}
.cus:hover img.fx {
  content: url('/static/home/tools/fx-choose.png');
}
.cus:hover img.db {
  content: url('/static/home/tools/db-choose.png');
}
.cus {
  position: relative;
  cursor: pointer;
}
.cus .text {
  position: absolute;
  bottom: 12px;
  font-size: 10px;
  width: 60px;
  text-align: center;
}
.cus:hover .text {
  color: #F3F2F7;
}
.el-dialog {
  width: 50%;
  height: 50%;
  margin-right: 50%;
  margin-top: 20%;
}

.shareshow {
  background-color: white;
  opacity: 1;
}
.shareshow .share-title{
  display:flex;
  justify-content: space-between;
  vertical-align:center;
  margin-bottom: 3px;
}
.shareshow .share-title .share-mail {
  padding: 5px 10px;
  display:flex;
  justify-content: center;
  vertical-align:center;
  background-color:#f0f0f0;
  border-radius: 5px;
}
.shareshow .share-title .share-mail .el-icon-message {
  color: #635796;
}
.shareshow .share-title .share-button {
  width: 86px;
  height: 32px;
  background: #635796;
  border-radius: 4px;
  color: #ffffff;
  padding: 0;
}
.shareshow .share-content {
  background-color:#f0f0f0;
  padding: 5px;
  border-radius: 3px;
}
.shareshow .share-content .input-box {
  display: flex;
  margin: 5px 0;
}
.shareshow .share-content .input-box .input-title {
  width: 35%;
  line-height: 40px;
  text-align: right;
}
.shareshow .share-content .input-box .input {
  width: 70%;
  font-size: 1rem;
  line-height: 12px;
}

.kfshow {
    background-color: #F0F0F0;
}
::v-deep .el-card {
  text-align: left;
}
::v-deep .el-card__body,
::v-deep .el-main {
  padding: 2px 10px;
}

.kfshow .service-title {
  display:flex;
  justify-content: center;
  vertical-align:center;
}
.kfshow .service-title img {
  height: 30px;
  vertical-align:bottom;
}
.kfshow .service-title .service-span {
  font-size: 1.1428rem;
  line-height: 30px;
  padding-left: 10px;
}

.bgcolor {
    background-color: #F0F0F0;
    padding: 2px;
}

.bgwhite{
     background-color: white;
    margin-top: 2px;
    padding: 4px;
    border-radius: 5px;
    color: #333333;
    text-align: center;
}

.total {
  position: absolute;
  left: 0;
  top: 10px;
  font-size: 12px;
  color: #fff;
  width: 18px;
  text-align: center;
}

.required {
  color: #F56C6C;
}

::v-deep .el-textarea__inner {
  padding: 0 15px;
}
</style>
